import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function GlobalSettings() {
  return (
    <Page
      title='User Config'
      breadcrumbs={[
        {
          label: 'Global Settings',
        },
        {
          label: 'User Config',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/user-config',
  component: GlobalSettings,
  type: 'auth',
});
